import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';
import {Body} from 'shells/typography/body';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function LandingPagesInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.LANDING_PAGES_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={<img src='/include/images/onboarding/pushing-website.svg' alt='Website' />}
            title='Begin creating engaging pages'
            body={
                <>
                    <Body>
                        Explore our comprehensive features for designing landing pages that deliver
                        results.
                    </Body>
                    <p>
                        <BulletedList
                            bullets={[
                                <span key='bullet-1'>
                                    Personalize a template or start from scratch using our intuitive
                                    drag-and-drop editor
                                </span>,
                                <span key='bullet-2'>
                                    Ensure your pages are responsive and display perfectly on all
                                    screens, from desktop to mobile
                                </span>,
                                <span key='bullet-3'>
                                    Track page performance and optimize for success using integrated
                                    analytics
                                </span>,
                            ]}
                        />
                    </p>
                </>
            }
            learnEvenMoreHref='https://www.nutshell.com/blog/high-conversion-landing-pages'
        />
    );
}
